import React, { useState } from 'react';
import { Plus, Pencil } from 'lucide-react';
import { useRemote, money } from './api';
import { useApp } from './context';
import { Action, PageTitle, LoadState, Empty } from './ui';
import { ProductForm } from './supplier/ProductForm';

const INITIAL = { name: '', sku: '', description: '', category: 'mechanical', industry: 'Manufacturing', grade: '',
  standard: '', hsn: '', packaging: 'Carton', unit: 'pieces', moq: 10, stock: 1000, lead_days: 7, gst_percent: 18,
  image_url: '', specs: {}, tiers: [{ min_qty: 10, price: 100 }, { min_qty: 50, price: 95 }, { min_qty: 200, price: 90 }] };

const SupplierProducts = ({ remote, edit }) => {
  if (remote.loading || remote.error) return <LoadState remote={remote} />;
  if (!remote.data?.length) return <Empty title="Publish your first product" text="Add specifications, MOQ and volume pricing to start receiving RFQs." />;
  return <div className="table-scroll"><table data-testid="supplier-products-table">
    <thead><tr><th>Product / SKU</th><th>MOQ</th><th>Stock</th><th>From / unit</th><th /></tr></thead>
    <tbody>{remote.data.map(product => <tr key={product.id}>
      <td><strong>{product.name}</strong><small className="table-sub mono">{product.sku}</small></td>
      <td>{product.moq} {product.unit}</td><td data-testid={`supplier-stock-${product.id}`}>{product.stock}</td>
      <td data-testid={`supplier-price-${product.id}`}>{money(product.tiers[0].price * 100)}</td>
      <td><button className="icon-button" data-testid={`edit-product-${product.id}`} aria-label={`Edit ${product.name}`}
        onClick={() => edit(product)}><Pencil size={16} /></button></td>
    </tr>)}</tbody>
  </table></div>;
};

const SupplierWorkspace = () => {
  const remote = useRemote('/products?mine=true');
  const [editing, setEditing] = useState(null);
  const title = editing ? (editing.id ? 'Edit listing.' : 'Add a product.') : 'Your product catalog.';
  const saved = () => { setEditing(null); remote.reload(); };
  return <>
    <PageTitle eyebrow="YOUR PRODUCTS. YOUR OPPORTUNITY." title={title}
      action={!editing && <Action id="add-product" onClick={() => setEditing(INITIAL)}><Plus size={17} />Add product</Action>}>
      Technical detail that makes sourcing decisions easier.
    </PageTitle>
    {editing ? <ProductForm key={editing.id || 'new'} initial={editing} cancel={() => setEditing(null)} saved={saved} />
      : <SupplierProducts remote={remote} edit={setEditing} />}
  </>;
};

export default function SupplierCatalog() {
  const { user } = useApp();
  if (user.role !== 'supplier') return <Empty title="Supplier workspace only" text="Catalog management is available to supplier accounts." />;
  if (user.approval !== 'approved') return <Empty title="Your catalog starts with approval"
    text="Once your business is approved, you can publish and manage products here." />;
  return <SupplierWorkspace />;
}